import {
  globalConstants,
  initialPagination,
  adminReduxConstants,
} from "../../constants";

const {
  GET_FAQS,
  GET_AGENTS,
  GET_APPROVALS,
  GET_CUSTOMERS,
  GET_SUB_ADMINS,
  GET_AGENT_DETAILS,
  AGENTS_PAGINATION,
  GET_DASHBOARD_DATA,
  GET_CUSTOMER_DETAILS,
  GET_AGENT_PROPERTIES,
  APPROVALS_PAGINATION,
  CUSTOMERS_PAGINATION,
  SUB_ADMINS_PAGINATION,
  GET_COUNTRIES_SETTINGS,
  GET_ADMIN_NOTIFICATIONS,
  AGENT_PROPERTIES_PAGINATION,
  COUNTRIES_SETTINGS_PAGINATION,
  GET_COUNTRIES_SETTINGS_DETAILS,
  GET_CUSTOMERS_EXPORT_ALL_DATA,
  GET_SUB_ADMINS_EXPORT_ALL_DATA,
  GET_AGENTS_APPROVALS_EXPORT_ALL_DATA,
  GET_AGENTS_CURRENT_LIST_EXPORT_ALL_DATA,
} = adminReduxConstants;
const { SUCCESS } = globalConstants;

const initialState = {
  FAQs: [],
  agents: [],
  subAdmins: [],
  customers: [],
  approvals: [],
  dashboard: {},
  agentDetails: {},
  customerDetails: {},
  approvalDetails: {},
  agentProperties: [],
  countriesSettings: [],
  adminNotifications: [],
  countriesSettingsDetails: {},
  agentsPagination: initialPagination,
  subAdminsPagination: initialPagination,
  customersPagination: initialPagination,
  approvalsPagination: initialPagination,
  agentPropertiesPagination: initialPagination,
  countrySettingsPagination: initialPagination,
  customersAllItemsForExport: [],
  subAdminsAllItemsForExport: [],
  agentsApprovalsAllItemsForExport: [],
  agentsCurrentListAllItemsForExport: [],
};

export const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUB_ADMINS + SUCCESS:
      return {
        ...state,
        subAdmins: action.data.items,
        subAdminsPagination: {
          ...state.subAdminsPagination,
          total: action.data.total,
        },
      };
    case GET_CUSTOMERS + SUCCESS:
      return {
        ...state,
        customers: action.data.items,
        customersPagination: {
          ...state.customersPagination,
          total: action.data.total,
        },
      };
    case GET_CUSTOMER_DETAILS + SUCCESS:
      return {
        ...state,
        customerDetails: action.data,
      };
    case GET_AGENTS + SUCCESS:
      return {
        ...state,
        agents: action.data.items,
        agentsPagination: {
          ...state.agentsPagination,
          total: action.data.total,
        },
      };
    case GET_APPROVALS + SUCCESS:
      return {
        ...state,
        approvals: action.data.items,
        approvalsPagination: {
          ...state.approvalsPagination,
          total: action.data.total,
        },
      };
    case GET_AGENT_PROPERTIES + SUCCESS:
      return {
        ...state,
        agentProperties: action.data,
      };
    case GET_COUNTRIES_SETTINGS + SUCCESS:
      return {
        ...state,
        countriesSettings: action.data.items,
        countrySettingsPagination: {
          ...state.countrySettingsPagination,
          total: action.data.total,
        },
      };
    case GET_COUNTRIES_SETTINGS_DETAILS + SUCCESS:
      return {
        ...state,
        countriesSettingsDetails: action.data,
      };
    case GET_AGENT_DETAILS + SUCCESS:
      return { ...state, agentDetails: action.data };
    case SUB_ADMINS_PAGINATION:
      return { ...state, subAdminsPagination: action.data };
    case CUSTOMERS_PAGINATION:
      return { ...state, customersPagination: action.data };
    case AGENTS_PAGINATION:
      return { ...state, agentsPagination: action.data };
    case APPROVALS_PAGINATION:
      return { ...state, approvalsPagination: action.data };
    case COUNTRIES_SETTINGS_PAGINATION:
      return { ...state, countrySettingsPagination: action.data };
    case GET_ADMIN_NOTIFICATIONS + SUCCESS:
      return { ...state, adminNotifications: action.data };
    case GET_FAQS + SUCCESS:
      return { ...state, FAQs: action.data };
    case GET_DASHBOARD_DATA + SUCCESS:
      return { ...state, dashboard: action.data };
    case AGENT_PROPERTIES_PAGINATION:
      return { ...state, agentPropertiesPagination: action.data };
    case GET_CUSTOMERS_EXPORT_ALL_DATA + SUCCESS:
      return { ...state, customersAllItemsForExport: action.data || [] };
    case GET_SUB_ADMINS_EXPORT_ALL_DATA + SUCCESS:
      return { ...state, subAdminsAllItemsForExport: action.data || [] };
    case GET_AGENTS_APPROVALS_EXPORT_ALL_DATA + SUCCESS:
      return { ...state, agentsApprovalsAllItemsForExport: action.data || [] };
    case GET_AGENTS_CURRENT_LIST_EXPORT_ALL_DATA + SUCCESS:
      return {
        ...state,
        agentsCurrentListAllItemsForExport: action.data || [],
      };
    default:
      return { ...state };
  }
};
